import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { FormsModule}   from '@angular/forms';
import { Observable } from 'rxjs/';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {LogService,AuthService} from 'core-dashboard';

@Component({
    selector: 'content-template',
    templateUrl: './login.component.template.html',
   // styleUrls: ['/app/css/login.css'],
   // providers: [WSIService]
})

export class LoginComponent {
   
     title = 'Login';
     errorMessage: string;
     wsiUrl: string = "";
     username: string = "";
     password: string = "";
     

    constructor(private _authService: AuthService, private router: Router, private logger: LogService) {
        
    }

    Login() {
        try{
            
        //this.logger.logInfo( "LoginComponent","Login called.");
        this._authService.Login(this.username, this.password,this.wsiUrl).subscribe(
            response => {
                try{
                if (response) {
                 
                    this.router.navigate(['/dashboard'],{ skipLocationChange: false,queryParamsHandling:"preserve"});
                     this.errorMessage = "Login Successful !!";
                } else {
                    //this.logger.logError( "LoginComponent","Login failed.");
                    this.errorMessage = "Login failed !"
                }
                //this.logger.logInfo( "LoginComponent","Login Recd.");
                }
            catch(error)
            {
                
                console.log(error);
            }
            }, error => this.errorMessage = <any>error
        );  
        }
    catch(error) 
    {
        
        console.log(error);
    }
    }
}  